import { gql } from "@urql/core";

export const statementsMetadataFragment = gql`
  fragment statementsMetadata on StatementsMetadataRecord {
    totalCredits
    totalDebits
    startDate
    endDate
    count
  }
`;

export const transactionFragment = gql`
  fragment statementTransaction on StatementTransactionRecord {
    kind
    amount
    createdAt
    date
    description
    merchant
    category
    categoryDetail
    paymentChannel
    location {
      address
      city
      country
      postalCode
      region
      storeNumber
    }
    statement {
      fileName
      fileUrl
    }
  }
`;
